import styles from "../ArtifactGrid/UploadGridItem.module.css";
import { useDispatch, useSelector } from "react-redux";
import {
    setImageDeleteMode,
    addImageToDeleteList,
    removeImageFromDeleteList
} from "../../store/actions/Inspections";
import { ImageDeleteData } from "../../types/ImageDeleteData";
import SurveyorCompletionStatus from "../../types/SurveyorCompletionStatus";
import {PortalState} from "../../types/PortalState";

interface Props {
    assetId: string;
    elementId: string;
}

const isSelectedForDelete = (
    assetId: string,
    imagesDeleteList: ImageDeleteData[]
) => {
    if (
        imagesDeleteList &&
        imagesDeleteList.find((image) => image.assetId === assetId) !==
            undefined
    ) {
        return true;
    }

    return false;
};

const ImageDeleteCheckbox = (props: Props) => {
    const dispatch = useDispatch();

    const surveyorCompletionStatus: SurveyorCompletionStatus | undefined =
        useSelector(
            (state: PortalState) =>
                state.portal.activeInspection?.SurveyorCompletionStatus
        );


    const inDeleteMode: boolean = useSelector(
        (state: any) => state.portal.activeInspection.ImageDeleteMode
    );
    const imagesDeleteList: ImageDeleteData[] = useSelector(
        (state: any) => state.portal.activeInspection.ImageDeleteList
    );

    function onChangeHandle(onClickEvent: any) {
        const thisCheckbox = onClickEvent.target as HTMLInputElement;

        if (thisCheckbox.checked) {
            dispatch(
                addImageToDeleteList({
                    elementId: props.elementId,
                    assetId: props.assetId
                })
            );

            if (!inDeleteMode) dispatch(setImageDeleteMode(true));
        } else {
            dispatch(
                removeImageFromDeleteList({
                    elementId: props.elementId,
                    assetId: props.assetId
                })
            );

            if (imagesDeleteList.length === 1)
                dispatch(setImageDeleteMode(false));
        }
        onClickEvent.stopPropagation();
    }

    function onClickHandle(onClickEvent: any) {
        onClickEvent.stopPropagation();
    }

    return (
        <div
            className={
                !surveyorCompletionStatus?.PhotosComplete
                    ? styles.deleteCheckboxInDeleteMode
                    : styles.deleteCheckbox
            }
        >
            <input
                name="deleteCheckbox" // Used by the Select All and Cancel event handlers to find the checkboxes associated with deleting photos
                type="checkbox"
                onChange={onChangeHandle}
                onClick={onClickHandle}
                checked={isSelectedForDelete(props.assetId, imagesDeleteList)}
                data-element-id={props.elementId}
                data-asset-id={props.assetId}
            />
        </div>
    );
};

export { ImageDeleteCheckbox, isSelectedForDelete };
